import Validator from '@croco/validator'
import Sync from '@croco/sync'
import di from 'dependeny-injection';
import emitter from 'es6-event-emitter';

class Info_log {
    /**
     * コンストラクタ
     *
     * @access public
     * @return void
     */
    constructor() {
        this.sync = new Sync();
        this.emitter = new emitter();
    }


    get(portfolio_id){
        return this.sync.post("/info-logs", {});
    }
} // class Register

// 確実に呼び出されるオブジェクト
di.set('info_log', new Info_log());

